export default __webpack_public_path__ + "static/media/boy.cfdbf22f.png";